import {
  GetListsRequestParamsI,
  GetListViewRowsRequestParamsI,
  GetListsRequestFilterParamsI,
  GetListsRequestSortParamsI,
} from "@/api/routes/list";

export const LIST_WORKSPACE_QUERY_KEY = "list_workspace";

export const LISTS = "lists";

export const VIEWS = "views";

export const VIEW = "view";

export const ROWS = "rows";

export const CONTACTS = "contacts";

export const AVAILABLE_COLUMNS = "available_columns";

export const ADDABLE_SOURCE_COLUMNS = "addable_source_columns";

export const SEARCH_GLOBAL = "search_global";

export const PULL_FILTER_OPTIONS = "pull_filter_options";

//Moved from pipeline module
export const LISTS_QUERY_KEY = "lists";
export const SEARCH_CONTACTS_QUERY_KEY = "contacts";
//--------------------------------

export const listWorkspaceQueryKeys = {
  lists: () => [LIST_WORKSPACE_QUERY_KEY, LISTS],
  list: (listId: string) => [LIST_WORKSPACE_QUERY_KEY, LISTS, listId],
  listViews: (listId: string) => [
    LIST_WORKSPACE_QUERY_KEY,
    LISTS,
    listId,
    VIEWS,
  ],
  view: (viewId: string) => [LIST_WORKSPACE_QUERY_KEY, VIEW, viewId],
  rows: (viewId: string, params?: Partial<GetListViewRowsRequestParamsI>) => [
    LIST_WORKSPACE_QUERY_KEY,
    VIEW,
    viewId,
    ROWS,
    params,
  ],
  listContacts: (listId: string, parameters?: GetListsRequestParamsI) => [
    LIST_WORKSPACE_QUERY_KEY,
    LISTS,
    listId,
    CONTACTS,
    parameters,
  ],
  availableColumns: () => [LIST_WORKSPACE_QUERY_KEY, AVAILABLE_COLUMNS],
  // Under view(viewId): a change to the view refetches what it can still add.
  addableSourceColumns: (viewId: string) => [
    LIST_WORKSPACE_QUERY_KEY,
    VIEW,
    viewId,
    ADDABLE_SOURCE_COLUMNS,
  ],
  searchGlobal: (searchTerm: string) => [
    LIST_WORKSPACE_QUERY_KEY,
    SEARCH_GLOBAL,
    searchTerm,
  ],
  // Not under LISTS: every pull invalidates lists() by prefix. A pull
  // invalidates this key on its own, once, because it can empty the pool.
  pullFilterOptions: (listId: string) => [
    LIST_WORKSPACE_QUERY_KEY,
    PULL_FILTER_OPTIONS,
    listId,
  ],
};

//TODO refactor to gracefully make part of list workspace
// for now just moved from pipeline
export const getListDetailsQueryKey = (listId: string) => [
  LISTS_QUERY_KEY,
  listId,
];

export interface GetListContactsQueryKeyConfigI {
  sortParams?: GetListsRequestSortParamsI;
  filters?: GetListsRequestFilterParamsI;
}

export const getListContactsQueryKey = (
  listId: string,
  config?: GetListContactsQueryKeyConfigI
) => {
  const { sortParams, filters } = config || {};

  const baseKey: any[] = [
    LISTS_QUERY_KEY,
    listId,
    "contacts",
    sortParams,
    filters,
  ];

  return baseKey;
};
